import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatSelectChange } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CountriesService } from '../../shared/services/countries.service';
import { formatPhoneString, undoPhoneFormat } from '../../util/phone';
import { OverviewService } from '../service/overview.service';
import * as moment from 'moment-timezone';
var EditIslandOverviewComponent = /** @class */ (function () {
    function EditIslandOverviewComponent(matDialogRef, data, overviewService, countriesService) {
        this.matDialogRef = matDialogRef;
        this.overviewService = overviewService;
        this.countriesService = countriesService;
        this.isLoading = true;
        this.countrySelectId = '1';
        this.timezoneSelectId = '2';
        this.postalCodePlaceHolder = '';
        this.states = new Array();
        this.statesMailing = new Array();
        this.airport = data.airport; // data object defined in parent;
    }
    EditIslandOverviewComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_1, _b, e_2;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        // Defining form controls and validation.
                        this.formGroup = new FormGroup({
                            title: new FormControl(this.airport.name, [Validators.required, Validators.maxLength(50)]),
                            icaoId: new FormControl(this.airport.icaoId, [Validators.maxLength(4)]),
                            street1: new FormControl(this.airport.address1, [Validators.required, Validators.maxLength(80)]),
                            street2: new FormControl(this.airport.address2, [Validators.maxLength(80)]),
                            stateProvince: new FormControl(''),
                            postalCode: new FormControl(this.airport.postalCode),
                            city: new FormControl(this.airport.city, [Validators.required, Validators.maxLength(40)]),
                            country: new FormControl('', [Validators.required]),
                            phone: new FormControl(formatPhoneString(this.airport.mainPhone), [Validators.pattern('^([(]\\d{3}[)]\\s\\d{3}[-]\\d{4})$')]),
                            webAddress: new FormControl(this.airport.website, [Validators.maxLength(100)]),
                            email: new FormControl(this.airport.email, [Validators.maxLength(55), this.customEmailValidator]),
                            timezone: new FormControl(this.airport.timeZone)
                        });
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.countriesService.getCountries()];
                    case 2:
                        _a.countries = _c.sent();
                        this.timezones = moment.tz.names();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _c.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4:
                        if (!this.airport.country) return [3 /*break*/, 8];
                        _c.label = 5;
                    case 5:
                        _c.trys.push([5, 7, , 8]);
                        _b = this;
                        return [4 /*yield*/, this.countriesService.getStates(this.airport.country)];
                    case 6:
                        _b.states = _c.sent();
                        this.states.length ? this.formGroup.controls['stateProvince'].setValidators([Validators.required, Validators.maxLength(50)]) :
                            this.formGroup.controls['stateProvince'].setValidators([Validators.maxLength(30)]);
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _c.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 8];
                    case 8:
                        this.isLoading = false;
                        this.formGroup.patchValue({ country: this.airport.country || '' });
                        this.formGroup.patchValue({ stateProvince: this.airport.stateProvince || '' });
                        this._setPostalCodeValidation(this.airport.country);
                        return [2 /*return*/];
                }
            });
        });
    };
    EditIslandOverviewComponent.prototype.customEmailValidator = function (control) {
        if (!control.value) {
            return null;
        }
        return Validators.email(control);
    };
    /**
     * triggered when value inside countries dropdown changes; event.value contains two digit country code.
     * @param {MatSelectChange} event
     * @return {Promise<void>}
     */
    EditIslandOverviewComponent.prototype.countryChange = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // if value property is empty return
                        if (!event.value) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this._setAddressForm(event.value)];
                    case 1:
                        _a.sent();
                        if (event.value === this.airport.country) {
                            this.formGroup.patchValue({ stateProvince: this.airport.stateProvince || '' });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered when value inside timezone dropdown changes; event.value contains timezone string from moment.timezone.names.
     * @param {MatSelectChange} event
     * @return {Promise<void>}
     */
    EditIslandOverviewComponent.prototype.timezoneChange = function (event) {
        // if value property is empty return
        if (!event.value) {
            return;
        }
        if (event.value === this.airport.timeZone) {
            this.formGroup.patchValue({ timezone: this.airport.timeZone || '' });
        }
    };
    /**
     * changes states dropdown when a different country is chosen.
     * also changes validators depending on whether or states list exists for country
     * @param {string} value
     * @return {Promise<void>}
     * @private
     */
    EditIslandOverviewComponent.prototype._setAddressForm = function (value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_3;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.countriesService.getStates(value)];
                    case 2:
                        _a.states = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _b.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4:
                        this.formGroup.patchValue({ stateProvince: '' });
                        this.isLoading = false;
                        if (!this.states.length) {
                            this.formGroup.controls['stateProvince'].setValidators([]);
                        }
                        else {
                            this.formGroup.controls['stateProvince'].setValidators([Validators.required]);
                        }
                        this._setPostalCodeValidation(value);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * If countryCode is 'US', Postal Code field becomes required.
     * @param {string} countryCode
     * @private
     */
    EditIslandOverviewComponent.prototype._setPostalCodeValidation = function (countryCode) {
        if (countryCode === 'US') {
            this.postalCodePlaceHolder = 'Zip Code *';
            this.formGroup.controls['postalCode'].setValidators([
                Validators.required,
                Validators.pattern('^\\d{5}$')
            ]);
            this.formGroup.controls['postalCode'].updateValueAndValidity();
        }
        else {
            this.postalCodePlaceHolder = 'Postal Code';
            this.formGroup.controls['postalCode'].setValidators([Validators.maxLength(9)]);
            this.formGroup.controls['postalCode'].updateValueAndValidity();
        }
    };
    /**
     * formats passed in phone number string;
     * @param {string} field
     * @param {string} value
     * @return {string}
     */
    EditIslandOverviewComponent.prototype.formatPhoneNumber = function (field, value) {
        var _a;
        var NEW_NUMBER = formatPhoneString(value);
        this.formGroup.patchValue((_a = {}, _a[field] = NEW_NUMBER, _a));
        return NEW_NUMBER;
    };
    /**
     * event triggered by keyup event on phone number or fax fields
     * @param event
     * @param {string} field
     * @param phoneInputObj
     */
    EditIslandOverviewComponent.prototype.phoneFieldKeyUp = function (event, field, phoneInputObj) {
        var value = this.formGroup.get(field).value;
        var rawValue = undoPhoneFormat(value);
        var KEY = event.key;
        if (KEY === 'Backspace' && rawValue.length === 10 && phoneInputObj.selectionStart === rawValue.length) {
            this.formatPhoneNumber(field, value);
        }
        else if (phoneInputObj.selectionStart < value.length) {
        }
        else if (KEY === 'Backspace' || KEY === 'ArrowLeft' || KEY === 'ArrowRight') {
            return;
        }
        else {
            this.formatPhoneNumber(field, value);
        }
    };
    /**
     * triggered when phone number or fax field goes out of focus
     * @param {string} field
     */
    EditIslandOverviewComponent.prototype.phoneFieldBlur = function (field) {
        var VALUE = this.formGroup.get(field).value;
        if (VALUE === '') {
            return;
        }
        this.formatPhoneNumber(field, VALUE);
    };
    /**
     * closes modal
     */
    EditIslandOverviewComponent.prototype.close = function (result) {
        if (result === void 0) { result = { cancelBtnClicked: true, success: false }; }
        if (result) {
            this.matDialogRef.close(result);
        }
    };
    /**
     * submits form values to api server if formGroup.valid property is true
     * @return {Promise<void>}
     */
    EditIslandOverviewComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var TEMP_AIRPORT, e_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        TEMP_AIRPORT = this.airport;
                        if (!this.formGroup.valid) {
                            return [2 /*return*/];
                        }
                        // form values are mapped to airport object before api call.
                        this.airport.name = this.formGroup.value.title;
                        this.airport.icaoId = this.formGroup.value.icaoId;
                        // airport address
                        this.airport.address1 = this.formGroup.value.street1;
                        this.airport.address2 = this.formGroup.value.street2 || null;
                        this.airport.stateProvince = this.formGroup.value.stateProvince || null;
                        this.airport.postalCode = this.formGroup.value.postalCode || null;
                        this.airport.city = this.formGroup.value.city;
                        this.airport.country = this.formGroup.value.country || null;
                        // contact info & web address
                        this.airport.mainPhone = undoPhoneFormat(this.formGroup.value.phone);
                        this.airport.website = this.formGroup.value.webAddress;
                        this.airport.email = this.formGroup.value.email;
                        this.airport.timeZone = this.formGroup.value.timezone;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.overviewService.putIslandAirport(this.airport)];
                    case 2:
                        _a.sent();
                        this.close({ cancelBtnClicked: false, success: true, airport: this.airport });
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _a.sent();
                        this.airport = TEMP_AIRPORT;
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return EditIslandOverviewComponent;
}());
export { EditIslandOverviewComponent };
